// Module
var code = `<div id="sidepanels">
    <se-text id="sidepanel_handle" title="ui.panel_action" text="ui.panel"></se-text>
    <div id="sidepanel_content">
        <div id="layerpanel">
            <se-text id="layersLabel" text="layers.layers"></se-text>
            <fieldset id="layerbuttons">
                <se-button id="layer_new" title="layers.new" size="small" src="new.svg"></se-button>
                <se-button id="layer_delete" title="layers.del" size="small" src="delete.svg"></se-button>
                <se-button id="layer_rename" title="layers.rename" size="small" src="text.svg"></se-button>
                <se-button id="layer_up" title="layers.move_up" size="small" src="go_up.svg"></se-button>
                <se-button id="layer_down" title="layers.move_down" size="small" src="go_down.svg"></se-button>
                <se-button id="layer_moreopts" title="common.more_opts" size="small" src="context_menu.svg">
                </se-button>
            </fieldset>
            <table id="layerlist">
                <tr class="layer">
                    <td class="layervis"></td>
                    <td class="layername">Layer 1</td>
                </tr>
            </table>
            <se-select id="selLayerNames" title="layers.move_selected" label="layers.move_elems_to" options="Layer 1"
                values="layer1" value="layer1" disabled="disabled">
            </se-select>
        </div>
    </div>
</div>`;
// Exports
export default code;